var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_LOYALITY_SUBSCRIP_VERIFY = '/RUN_LOYALITY_SUBSCRIP_VERIFY';
    Const.RUN_BANK_DEPOSIT_FOR_FEW_COUNTRIES = '/RUN_BANK_DEPOSIT_FOR_FEW_COUNTRIES';
    Const.RUN_BITCOIN_CONVERSION = '/RUN_BITCOIN_CONVERSION';
    Const.RUN_SUBSCRIPTION_REQUEST_OTP = '/RUN_SUBSCRIPTION_REQUEST_OTP';
    Const.RUN_REQUEST_CALLBACK = '/RUN_REQUEST_CALLBACK';
    Const.RUN_SUBSCRIPTION_CHECK_OTP = '/RUN_SUBSCRIPTION_CHECK_OTP';
    Const.RUN_SUBSCRIPTION_RESEND_EMAIL_LINK = '/RUN_SUBSCRIPTION_RESEND_EMAIL_LINK';
    Const.RUN_UNSUBSCRIBE_REQUEST_OTP = '/RUN_UNSUBSCRIBE_REQUEST_OTP';
    Const.RUN_UNSUBSCRIBE_CHECK_OTP = '/RUN_UNSUBSCRIBE_CHECK_OTP';
    Const.RUN_Unsubscribe_RESEND_EMAIL_LINK = '/RUN_Unsubscribe_RESEND_EMAIL_LINK';
    Const.RUN_GET_NOTIFICATION_LIST = '/RUN_GET_NOTIFICATION_LIST';
    Const.SET_NOTIFICATION_LIST = '/SET_NOTIFICATION_LIST';
    Const.GET_NOTIFICATION_LIST = '/GET_NOTIFICATION_LIST';
    Const.RUN_READ_UNREAD_NOTIFICATION = '/RUN_READ_UNREAD_NOTIFICATION';
    Const.SET_UNREAD_NOTIFICATION_DATA = '/SET_UNREAD_NOTIFICATION_DATA';
    Const.GET_UNREAD_NOTIFICATION_DATA = '/GET_UNREAD_NOTIFICATION_DATA';
    Const.RUN_GET_SUBSCRIPTION_DETAIL = '/RUN_GET_SUBSCRIPTION_DETAIL';
    Const.SET_SUBSCRIPTION_DETAIL = '/SET_SUBSCRIPTION_DETAIL';
    Const.GET_SUBSCRIPTION_DETAIL = '/GET_SUBSCRIPTION_DETAIL';
    Const.GET_ZULU_ACCOUNT_LIST = '/GET_ZULU_ACCOUNT_LIST';
    Const.SET_ZULU_ACCOUNT_LIST = '/SET_ZULU_ACCOUNT_LIST';
    Const.RUN_LANGUAGE_API = '/RUN_LANGUAGE_API';
    //research & education
    Const.RUN_GET_WEBINAR_DATA = '/RUN_GET_WEBINAR_DATA';
    Const.RUN_GET_TUT_COURSE_CATEGORY = '/RUN_GET_TUT_COURSE_CATEGORY';
    //webinar
    Const.RUN_GET_VIDEO_TUTORIAL = '/RUN_GET_VIDEO_TUTORIAL';
    Const.SET_VIDEO_TUTORIAL = '/SET_VIDEO_TUTORIAL';
    Const.GET_VIDEO_TUTORIAL = '/GET_VIDEO_TUTORIAL';
    Const.RUN_GET_POST_DATA = '/RUN_GET_POST_DATA';
    Const.GET_EUROPEAN_COUNTRY_LIST = '/GET_EUROPEAN_COUNTRY_LIST';
    Const.GET_HELP2PAY_BANK_LIST = '/GET_HELP2PAY_BANK_LIST';
    Const.GET_HELP2PAY_AMOUNT_LIMIT = '/GET_HELP2PAY_AMOUNT_LIMIT';
    Const.GET_COUNTRY_CURRENCY = '/GET_COUNTRY_CURRENCY';
    //trading-tools
    Const.RUN_GET_AUTOCHARTIST_DATA = '/RUN_GET_AUTOCHARTIST_DATA';
    Const.RUN_GET_CURRENT_NEWS = '/RUN_GET_CURRENT_NEWS';
    Const.RUN_GET_CURRENT_NEWS_DETAIL = '/RUN_GET_CURRENT_NEWS_DETAIL';
    Const.GET_CURRENT_NEWS_DETAIL = '/GET_CURRENT_NEWS_DETAIL';
    Const.SET_CURRENT_NEWS_DETAIL = '/SET_CURRENT_NEWS_DETAIL';
    Const.RUN_GET_SIGNAL_CENTRE_DATA = '/RUN_GET_SIGNAL_CENTRE_DATA';
    Const.RUN_GET_ECONOMIC_CALENDER_DATA = '/RUN_GET_ECONOMIC_CALENDER_DATA';
    Const.RUN_GET_CALENDER_EVENT = '/RUN_GET_CALENDER_EVENT';
    Const.RUN_COUPON_PLAN = '/RUN_COUPON_PLAN';
    Const.RUN_GET_AUTO_CHARTIST_WEB_URL = '/RUN_GET_AUTO_CHARTIST_WEB_URL';
    Const.RUN_GET_SUB_PLAN_LIST = '/RUN_GET_SUB_PLAN_LIST';
    Const.RUN_GET_SUB_PLAN_DETAIL = '/RUN_GET_SUB_PLAN_DETAIL';
    Const.RUN_SUB_OPERATION_LINK = '/RUN_SUB_OPERATION_LINK';
    Const.RUN_SUB_OPERATION = '/RUN_SUB_OPERATION';
    Const.RUN_CREATE_SUB_TICKET = '/RUN_CREATE_SUB_TICKET';
    Const.RUN_UNSUB_SERVICE = '/RUN_UNSUB_SERVICE';
    Const.RUN_GET_VPS_LIST = '/RUN_GET_VPS_LIST';
    Const.RUN_GET_VPS_DETAIL = '/RUN_GET_VPS_DETAIL';
    Const.RUN_VPS_RESTART = '/RUN_VPS_RESTART';
    Const.RUN_VPS_REBOOT = '/RUN_VPS_REBOOT';
    Const.RUN_VPS_SHUTDOWN = '/RUN_VPS_SHUTDOWN';
    Const.RUN_VPS_CHANGE_PASSWORD = '/RUN_VPS_CHANGE_PASSWORD';
    Const.RUN_GET_COUPON_LIST = '/RUN_GET_COUPON_LIST';
    Const.RUN_CHECK_COUPON_VALIDITY = '/RUN_CHECK_COUPON_VALIDITY';
    Const.SET_COUPON_LIST = '/SET_COUPON_LIST';
    Const.GET_COUPON_LIST = '/GET_COUPON_LIST';
    Const.SET_VPS_LIST = '/SET_VPS_LIST';
    Const.GET_VPS_LIST = '/GET_VPS_LIST';
    Const.SET_VPS_DETAIL = '/SET_VPS_DETAIL';
    Const.GET_VPS_DETAIL = '/GET_VPS_DETAIL';
    Const.SET_SIGNAL_CENTRE = '/SET_SIGNAL_CENTRE';
    Const.GET_SIGNAL_CENTRE = '/GET_SIGNAL_CENTRE';
    Const.SET_AUTO_CHARTIST = '/SET_AUTO_CHARTIST';
    Const.GET_AUTO_CHARTIST = '/GET_AUTO_CHARTIST';
    Const.SET_ECONOMIC_CALENDER_DATA = '/SET_ECONOMIC_CALENDER_DATA';
    Const.GET_ECONOMIC_CALENDER_DATA = '/GET_ECONOMIC_CALENDER_DATA';
    Const.SET_CURRENT_NEWS = '/SET_CURRENT_NEWS';
    Const.GET_CURRENT_NEWS = '/GET_CURRENT_NEWS';
    Const.SET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY = '/SET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY';
    Const.GET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY = '/GET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY';
    Const.SET_SUB_PLAN_LIST = '/SET_SUB_PLAN_LIST';
    Const.GET_SUB_PLAN_LIST = '/GET_SUB_PLAN_LIST';
    Const.SET_SUB_PLAN_DETAIL = '/SET_SUB_PLAN_DETAIL';
    Const.GET_SUB_PLAN_DETAIL = '/GET_SUB_PLAN_DETAIL';
    //user
    Const.RUN_GET_USER_PROFILE = '/RUN_GET_USER_PROFILE';
    Const.RUN_GET_USER_REGISTERATION_STEP_DATA = '/RUN_GET_USER_REGISTERATION_STEP_DATA';
    Const.RUN_GET_COUNTRIES_LIST = '/RUN_GET_COUNTRIES_LIST';
    Const.RUN_GET_CITIES_LIST = '/RUN_GET_CITIES_LIST';
    Const.RUN_USER_NOTIFICATIONS = '/RUN_USER_NOTIFICATIONS';
    Const.SET_USER_PROFILE = '/SET_USER_PROFILE';
    Const.GET_USER_PROFILE = '/GET_USER_PROFILE';
    Const.SET_USER_NOTIFICATIONS = '/SET_USER_NOTIFICATIONS';
    Const.GET_USER_NOTIFICATIONS = '/GET_USER_NOTIFICATIONS';
    Const.SET_COUNTRIES_LIST = '/SET_COUNTRIES_LIST';
    Const.GET_COUNTRIES_LIST = '/GET_COUNTRIES_LIST';
    Const.SET_CITIES_LIST = '/SET_CITIES_LIST';
    Const.GET_CITIES_LIST = '/GET_CITIES_LIST';
    Const.GET_COUNTRY_TAX_RESIDENCE_NATIONALITY = '/GET_COUNTRY_TAX_RESIDENCE_NATIONALITY';
    Const.GET_EMP_STATUS = '/GET_EMP_STATUS';
    Const.GET_OCCUPATION = '/GET_OCCUPATION';
    Const.GET_EST_YEARLY_INCOME = '/GET_EST_YEARLY_INCOME';
    Const.GET_EST_NET_WORTH = '/GET_EST_NET_WORTH';
    Const.GET_ANT_ACCOUNT_TURNOVER = '/GET_ANT_ACCOUNT_TURNOVER';
    Const.GET_TIN_PASSPORT_OPTION = '/GET_TIN_PASSPORT_OPTION';
    Const.GET_SOURCE_OF_FUNDS = '/GET_SOURCE_OF_FUNDS';
    //manage accounts
    Const.RUN_AMOUNT_CONVERSION_API = '/RUN_AMOUNT_CONVERSION_API';
    Const.RUN_ACCOUNT_PASSWORD_REQUEST_OTP = '/RUN_ACCOUNT_PASSWORD_REQUEST_OTP';
    Const.RUN_ACCOUNT_PASSWORD_CHECK_OTP = '/RUN_ACCOUNT_PASSWORD_CHECK_OTP';
    Const.RUN_ACCOUNT_LEVERAGE_CHECK_OTP = '/RUN_ACCOUNT_LEVERAGE_CHECK_OTP';
    Const.RUN_INTERNAL_TRANSFER_CHECK_OTP = '/RUN_INTERNAL_TRANSFER_CHECK_OTP';
    Const.RUN_RESEND_EMAIL_LINK_ACCOUNTS = '/RUN_RESEND_EMAIL_LINK_ACCOUNTS';
    //trading accounts
    Const.RUN_GET_ACCOUNT_PRIORITY_LIST = '/RUN_GET_ACCOUNT_PRIORITY_LIST';
    Const.RUN_GET_TRADING_ACCOUNT_LIST = '/RUN_GET_TRADING_ACCOUNT_LIST';
    Const.RUN_GET_ACCOUNT_HISTORY = '/RUN_GET_ACCOUNT_HISTORY';
    Const.RUN_ADD_LAST_SELECT_TRADING_ACCOUNT = '/RUN_ADD_LAST_SELECT_TRADING_ACCOUNT';
    Const.RUN_GET_TRADING_ACCOUNT_DETAILS = '/RUN_GET_TRADING_ACCOUNT_DETAILS';
    Const.RUN_CREATE_ACCOUNT = '/RUN_CREATE_ACCOUNT';
    Const.RUN_CREATE_API_SUBSCRIPTION = '/RUN_CREATE_API_SUBSCRIPTION';
    Const.SET_TRADING_ACCOUNT_LIST = '/SET_TRADING_ACCOUNT_LIST';
    Const.GET_TRADING_ACCOUNT_LIST = '/GET_TRADING_ACCOUNT_LIST';
    Const.SET_LIVE_ACCOUNT_LIST = '/SET_LIVE_ACCOUNT_LIST';
    Const.GET_LIVE_ACCOUNT_LIST = '/GET_LIVE_ACCOUNT_LIST';
    Const.SET_DEMO_ACCOUNT_LIST = '/SET_DEMO_ACCOUNT_LIST';
    Const.GET_DEMO_ACCOUNT_LIST = '/GET_DEMO_ACCOUNT_LIST';
    Const.SET_LAST_SELECT_TRADING_ACCOUNT = '/SET_LAST_SELECT_TRADING_ACCOUNT';
    Const.GET_LAST_SELECT_TRADING_ACCOUNT = '/GET_LAST_SELECT_TRADING_ACCOUNT';
    Const.SET_ACCOUNT_DETAILS = '/SET_ACCOUNT_DETAILS';
    Const.GET_ACCOUNT_DETAILS = '/GET_ACCOUNT_DETAILS';
    //deposit
    Const.RUN_GET_PRAXIS_URL = '/RUN_GET_PRAXIS_URL';
    Const.RUN_DEMO_DEPOSIT = '/RUN_DEMO_DEPOSIT';
    Const.RUN_TRANS_LIMIT_CURRENCY = '/RUN_TRANS_LIMIT_CURRENCY';
    Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
    Const.RUN_GET_USER_CAN_DEPOSIT = '/RUN_GET_USER_CAN_DEPOSIT';
    Const.RUN_CREDIT_CARD_DEPOSIT = '/RUN_CREDIT_CARD_DEPOSIT';
    Const.RUN_CRYPTO_DEPOSIT = '/RUN_CRYPTO_DEPOSIT';
    Const.RUN_GET_TRANSACTION_STATUS = '/RUN_GET_TRANSACTION_STATUS';
    Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
    Const.SET_DEPOSIT_LIMIT = '/SET_DEPOSIT_LIMIT';
    Const.GET_DEPOSIT_LIMIT = '/GET_DEPOSIT_LIMIT';
    //withdrawal
    Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
    Const.RUN_WITHDRAWAL_REQUEST_OTP = '/RUN_WITHDRAWAL_REQUEST_OTP';
    Const.RUN_WITHDRAWAL_CHECK_OTP = '/RUN_WITHDRAWAL_CHECK_OTP';
    Const.RUN_RESEND_EMAIL_LINK = '/RUN_RESEND_EMAIL_LINK';
    Const.RUN_GET_WITHDRAWAL_METHODS = '/RUN_GET_WITHDRAWAL_METHODS';
    Const.RUN_GET_WITHDRAWAL_DESC = '/RUN_GET_WITHDRAWAL_DESC';
    Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
    Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/GET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/SET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    //bonus
    Const.RUN_TRADING_BONUS = '/RUN_TRADING_BONUS';
    Const.RUN_BONUS_REQUEST_OTP = '/RUN_BONUS_REQUEST_OTP';
    Const.RUN_BONUS_CHECK_OTP = '/RUN_BONUS_CHECK_OTP';
    Const.RUN_GET_BONUS_LIST = '/RUN_GET_BONUS_LIST';
    Const.RUN_REMOVE_BONUS = '/RUN_REMOVE_BONUS';
    Const.RUN_RESEND_EMAIL_LINK_BONUS = '/RUN_RESEND_EMAIL_LINK_BONUS';
    Const.SET_BONUS_LIST = '/SET_BONUS_LIST';
    Const.GET_BONUS_LIST = '/GET_BONUS_LIST';
    //support
    Const.RUN_GET_TICKET_LIST = '/RUN_GET_TICKET_LIST';
    Const.RUN_GET_TICKET_DETAIL = '/RUN_GET_TICKET_DETAIL';
    Const.RUN_TICKET_REQUEST_OTP = '/RUN_TICKET_REQUEST_OTP';
    Const.RUN_TICKET_CHECK_OTP = '/RUN_TICKET_CHECK_OTP';
    Const.RUN_TICKET_REPLY = '/RUN_TICKET_REPLY';
    Const.RUN_GET_TICKET_REASON_LIST = '/RUN_GET_TICKET_REASON_LIST';
    Const.RUN_TICKET_RESEND_OTP = '/RUN_TICKET_RESEND_OTP';
    Const.SET_TICKET_DATA = '/SET_TICKET_DATA';
    Const.GET_TICKET_DATA = '/GET_TICKET_DATA';
    Const.SET_TICKET_LIST = '/SET_TICKET_LIST';
    Const.GET_TICKET_LIST = '/GET_TICKET_LIST';
    Const.SET_TICKET_VIEW = '/SET_TICKET_VIEW';
    Const.GET_TICKET_VIEW = '/GET_TICKET_VIEW';
    Const.SET_TICKET_REASON_LIST = '/SET_TICKET_REASON_LIST';
    Const.GET_TICKET_REASON_LIST = '/GET_TICKET_REASON_LIST';
    Const.GET_REASON_LIST = '/GET_REASON_LIST';
    //dashboard charts
    Const.RUN_GET_PROFIT_CHART_DATA = '/RUN_GET_PROFIT_CHART_DATA';
    Const.RUN_GET_BALANCE_DATA = '/RUN_GET_BALANCE_DATA';
    Const.RUN_GET_EQUITY_DATA = '/RUN_GET_EQUITY_DATA';
    Const.RUN_GET_TRADING_DATA = '/RUN_GET_TRADING_DATA';
    Const.RUN_GET_IDENFY_TOKEN = '/RUN_GET_IDENFY_TOKEN';
    //bank-api
    Const.RUN_ADD_BANK = '/RUN_ADD_BANK';
    Const.RUN_GET_BANK_LIST = '/RUN_GET_BANK_LIST';
    Const.SET_BANK_LIST = '/SET_BANK_LIST';
    Const.GET_BANK_LIST = '/GET_BANK_LIST';
    Const.RUN_REFER_Friend = '/RUN_REFER_Friend';
    Const.RUN_GET_REFER_LIST = '/RUN_GET_REFER_LIST';
    Const.GET_REFER_LIST = '/GET_REFER_LIST';
    Const.SET_REFER_LIST = '/SET_REFER_LIST';
    Const.RUN_REFER_DELETE = '/RUN_REFER_DELETE';
    Const.RUN_GET_AUTOCHARTIST_URL = '/RUN_GET_AUTOCHARTIST_URL';
    Const.RUN_CONVERT_WALLET_BALANCE = '/RUN_CONVERT_WALLET_BALANCE';
    Const.RUN_GET_HOOPS_DATA = '/RUN_GET_HOOPS_DATA';
    Const.GET_HOOPS_DATA = '/GET_HOOPS_DATA';
    Const.SET_HOOPS_DATA = '/SET_HOOPS_DATA';
    Const.SET_ENTITY_DATA = '/SET_ENTITY_DATA';
    Const.GET_ENTITY_DATA = '/GET_ENTITY_DATA';
    //wallet
    Const.RUN_CREATE_WALLET_ACCOUNT = '/RUN_CREATE_WALLET_ACCOUNT';
    Const.RUN_GET_WALLET_BALANCE = '/RUN_GET_WALLET_BALANCE';
    Const.SET_WALLET_BALANCE = '/SET_WALLET_BALANCE';
    Const.GET_WALLET_BALANCE = '/GET_WALLET_BALANCE';
    Const.RUN_SWIFFY_DETAILS = '/RUN_SWIFFY_DETAILS';
    Const.RUN_HELP2PAY_PAYMENTINFO = '/RUN_HELP2PAY_PAYMENTINFO';
    Const.RUN_HELP2PAY_DETAILS = '/RUN_HELP2PAY_DETAILS';
    Const.RUN_HELP2PAY_CURRENCY_CONVERSION = '/RUN_HELP2PAY_CURRENCY_CONVERSION';
    Const.RUN_PAYGURU_DETAILS = '/RUN_PAYGURU_DETAILS';
    Const.RUN_ASTROPAY_DETAILS = '/RUN_ASTROPAY_DETAILS';
    Const.RUN_ASTROPAY_CURRENCY_CONVERSION = '/RUN_ASTROPAY_CURRENCY_CONVERSION';
    Const.RUN_PERFECT_MONEY_DETAILS = '/RUN_PERFECT_MONEY_DETAILS';
    Const.RUN_ALL_CURRENCY_LIST = '/RUN_ALL_CURRENCY_LIST';
    // Nuvei
    Const.RUN_NUVEI_DETAILS = '/RUN_NUVEI_DETAILS';
    Const.GET_NUVEI_DETAILS = '/GET_NUVEI_DETAILS';
    Const.SET_NUVEI_DETAILS = '/SET_NUVEI_DETAILS';
    // trustpay
    Const.RUN_GET_TRUST_PAY_DETAILS = '/RUN_GET_TRUST_PAY_DETAILS';
    Const.RUN_GET_WALLET_DETAIL = '/RUN_GET_WALLET_DETAIL';
    Const.SET_WALLET_ACCOUNT = '/SET_WALLET_ACCOUNT';
    Const.GET_WALLET_ACCOUNT = '/GET_WALLET_ACCOUNT';
    Const.SET_WALLET_CURRENCY_DATA = '/SET_WALLET_CURRENCY_DATA';
    Const.GET_WALLET_CURRENCY_DATA = '/GET_WALLET_CURRENCY_DATA';
    Const.RUN_GET_WALLET_TRANSACTION = '/RUN_GET_WALLET_TRANSACTION';
    Const.SET_WALLET_TRANSACTION = '/SET_WALLET_TRANSACTION';
    Const.GET_WALLET_TRANSACTION = '/GET_WALLET_TRANSACTION';
    Const.GET_ALL_ACCOUNT_LIST = '/GET_ALL_ACCOUNT_LIST';
    Const.SET_ALL_ACCOUNT_LIST = '/SET_ALL_ACCOUNT_LIST';
    //loyality
    Const.RUN_GET_LOYALITY_CARD_DETAIL = '/RUN_GET_LOYALITY_CARD_DETAIL';
    Const.RUN_GET_LOYALITY_TXN_LIST = '/RUN_GET_LOYALITY_TXN_LIST';
    Const.RUN_LOYALITY_REQUEST_OTP = '/RUN_LOYALITY_REQUEST_OTP';
    Const.RUN_LOYALITY_REDEEM_CHECK_OTP = '/RUN_LOYALITY_REDEEM_CHECK_OTP';
    Const.RUN_LOYALITY_TRANSFER_CHECK_OTP = '/RUN_LOYALITY_TRANSFER_CHECK_OTP';
    Const.RUN_LOYALITY_EMAIL_VERIFY_LINK = '/RUN_LOYALITY_EMAIL_VERIFY_LINK';
    Const.SET_LOYALITY_CARD_DETAIL = '/SET_LOYALITY_CARD_DETAIL';
    Const.GET_LOYALITY_CARD_DETAIL = '/GET_LOYALITY_CARD_DETAIL';
    Const.SET_LOYALITY_CARD_TXN = '/SET_LOYALITY_CARD_TXN';
    Const.GET_LOYALITY_CARD_TXN = '/GET_LOYALITY_CARD_TXN';
    Const.SET_LOYALITY_LAST_CREDIT = '/SET_LOYALITY_LAST_CREDIT';
    Const.GET_LOYALITY_LAST_CREDIT = '/GET_LOYALITY_LAST_CREDIT';
    Const.RUN_GET_CRYPTO_Methods = '/RUN_GET_CRYPTO_Methods';
    Const.RUN_ADD_CRYPTO_Methods = '/RUN_ADD_CRYPTO_Methods';
    Const.RUN_UPDATE_FIRST_DEPOSIT = '/RUN_UPDATE_FIRST_DEPOSIT';
    //cancel withdrawal request
    Const.RUN_CANCEL_WITHDRAWAL_REQUEST = '/RUN_CANCEL_WITHDRAWAL_REQUEST';
    Const.GET_ASTROPAY_METHODS = '/GET_ASTROPAY_METHODS';
    Const.RUN_ASTROPAY_AFFILIATE_LOGIN = '/RUN_ASTROPAY_AFFILIATE_LOGIN';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/provider/candle-history/lib/const.cls.ts
// module id = H1/N
// module chunks = 4